module.exports = __webpack_public_path__ + "img/Mask Group 140.29f75a65.svg";